module.exports = "<router-outlet></router-outlet> \r\n"


//////////////////
// WEBPACK FOOTER
// D:/Laxmi/angular/forms/XpressForms/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main